import { MentionCombobox } from "@react-fluent-edit/mentions";
import MentionElement from "../MentionElement";
import { withMentionNodes, withoutMentionNodes } from "../utils";
import withMentions from "../withMentions";
function createMentionsPlugin(options) {
    return {
        name: "mentions",
        element: {
            match: ({ element: { type } }) => type === "mention",
            component: MentionElement,
        },
        override: withMentions,
        beforeSerialize: {
            handler: (nodes) => {
                return withoutMentionNodes(nodes);
            },
        },
        afterDeserialize: {
            handler: (nodes, options) => {
                var _a;
                const allowedItems = (_a = options.componentProps) === null || _a === void 0 ? void 0 : _a.flatMap((props) => { var _a; return (_a = props === null || props === void 0 ? void 0 : props.MentionsCombobox) === null || _a === void 0 ? void 0 : _a.items; });
                const mentions = options.mentions;
                return withMentionNodes({
                    nodes,
                    mentions,
                    allowedItems,
                    disableCreatable: options.disableCreatable,
                });
            },
        },
        editorComponents: [MentionCombobox],
        options,
    };
}
export default createMentionsPlugin;
